import * as propTypes from 'lib/prop_types';

export const trackingPropsShape = {
  tracking: propTypes.shape({
    getTrackingData: propTypes.func,
    trackEvent: propTypes.func,
  }),
};
